var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topbar"
  }, [_c('div', {
    staticClass: "w1200 bc"
  }, [_c('ul', {
    staticClass: "topbar-right fr"
  }, [(_vm.isLogin == true) ? _c('li', [_c('span', [_vm._v("您好")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == true) ? _c('li', [_c('a', {
    staticClass: "co2",
    attrs: {
      "href": _vm.userCenterUrl
    }
  }, [_vm._v(_vm._s(_vm.account))])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == true) ? _c('li', [_c('a', {
    staticClass: "co2",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("[退出]")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticStyle: {
      "height": "30px",
      "width": "77px"
    },
    on: {
      "mouseenter": function($event) {
        _vm.shopCartShow()
      },
      "mouseleave": function($event) {
        _vm.shopCartHide()
      }
    }
  }, [_c('a', {
    on: {
      "click": _vm.toShopCart
    }
  }, [_vm._v("购物车")]), _vm._v("("), _c('a', {
    staticStyle: {
      "color": "#f60"
    }
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v(")\n\t\t\t\t\n\t\t\t\t"), (_vm.isShow) ? _c('div', {
    staticClass: "top_shopcart",
    attrs: {
      "id": "shopCartInfo"
    }
  }, [_c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), (_vm.shoppingCartNum == 0) ? _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/images/settleup-nogoods.png"),
      "width": "57",
      "height": "49"
    }
  }), _vm._v("购物车中还没有商品，赶紧选购吧！\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.shoppingCartNum > 0) ? _c('div', {
    staticClass: "mylist"
  }, [_c('h4', [_vm._v("最新加入的商品 ")]), _vm._v(" "), _c('ul', _vm._l((_vm.boList), function(bo, index) {
    return _c('li', {
      staticClass: "li-2",
      attrs: {
        "id": bo.goodsCode + '_cart_pro'
      }
    }, [_c('a', {
      staticClass: "fl spic",
      on: {
        "click": function($event) {
          _vm.toDetail(bo.goodsCode)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": bo.imgSmall,
        "width": "50",
        "height": "50"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "name"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toDetail(bo.goodsCode)
        }
      }
    }, [_c('span', {
      attrs: {
        "name": "goodsName"
      }
    }, [_vm._v(_vm._s(bo.goodsName))]), (bo.specName != '') ? _c('span', [_vm._v("【" + _vm._s(bo.specName) + "】")]) : _vm._e()]), _vm._v("    "), _c('span', {
      staticStyle: {
        "color": "#f60"
      }
    }, [_vm._v("数量：" + _vm._s(bo.goodsNumber))])]), _vm._v(" "), _c('p', {
      staticClass: "other"
    }, [_c('span', [_vm._v("￥" + _vm._s(bo.unitPrice))]), _c('br'), _vm._v(" "), _c('a', {
      staticClass: "del",
      on: {
        "click": function($event) {
          _vm.deleteGoods(bo.id, bo.goodsCode, index)
        }
      }
    }, [_vm._v("删除")])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "fbar"
  }, [_c('span', {
    staticClass: "fl ml10"
  }, [_vm._v("共" + _vm._s(_vm.count) + "件商品　共计"), _c('b', [_vm._v("￥ " + _vm._s(_vm.sumMoney))])]), _vm._v(" "), _c('a', {
    staticClass: "fr gobuy",
    on: {
      "click": _vm.toShopCart
    }
  }, [_vm._v("去购物车")])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.contactUrl,
      "target": "_blank"
    }
  }, [_vm._v("联系客服")])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('ul', {
    staticClass: "topbar-left fl"
  }, [_c('li', [_vm._v("\n\t\t\t\t您好！欢迎来到相伴宝！\n\t\t\t")]), _vm._v(" "), (_vm.isLogin == false) ? _c('li', [_c('a', {
    staticClass: "co2",
    attrs: {
      "href": _vm.loginUrl
    }
  }, [_vm._v("[登录]")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == false) ? _c('li', [_c('a', {
    staticClass: "co2",
    attrs: {
      "href": _vm.registerUrl
    }
  }, [_vm._v("[注册]")])]) : _vm._e()])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.baomate.com/aboutus/index.htm"
    }
  }, [_vm._v("关于我们")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://en.baomate.com",
      "target": "_blank"
    }
  }, [_vm._v("English")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1ecf252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopBar.vue
// module id = tFka
// module chunks = 1